import * as React from "react";

const CENPunchoutArrowrightlong: React.FC = () => {
    return (
        <svg width="50" height="36" viewBox="0 0 50 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M29.6037 25.2282L29.6028 25.2292C27.7963 27.0356 27.7963 29.9631 29.6028 31.7695C31.4076 33.5743 34.335 33.5776 36.1431 31.7695L46.6431 21.2695C48.4498 19.4628 48.4474 16.5438 46.6545 14.7365L46.6489 14.7308L36.1489 4.23081C34.3424 2.42437 31.415 2.42437 29.6085 4.23081C27.8021 6.03725 27.8021 8.96471 29.6085 10.7711L32.2138 13.3764H6.625C4.18463 13.3764 2 15.1853 2 17.9276C2 20.5218 4.03358 22.6264 6.625 22.6264H32.2091L29.6037 25.2282Z"
                fill="#E0DFE0"
                stroke="white"
                stroke-width="4"
            />
        </svg>
    );
};

export default React.memo(CENPunchoutArrowrightlong);
